import React from 'react'

import './index.scss'

const LinkUnderline = () => <span className="nav__link_underline" />

export default LinkUnderline
